import { render, staticRenderFns } from "./SuportRequestList.vue?vue&type=template&id=7df1dbe2"
import script from "./SuportRequestList.vue?vue&type=script&lang=js"
export * from "./SuportRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports